import React from 'react';
import _ from 'lodash';
import Cookies from 'js-cookie'; // eslint-disable-line
import moment from 'moment';
import {
  CLIENT_SETTINGS,
  EMPLOYEES_LIST,
  LIST_CLIENTS_URL,
  // CLIENT_GROUPS,
  COORDINATION_JBC_SETTINGS,
  EDIT_CLIENT_SETTING_USING_PLAN,
  COORDINATION_COMMON_ID_SETTINGS
} from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import Button from 'jbc-front/components/Button';
import { Section } from 'jbc-front/components/Form';
import { KintaiLogo, RoumuLogo, Link, UnLink, Setting } from 'jbc-front/components/icons';
import { HYPHEN_CHARACTER } from 'src/constants/Generals';
import styles from './ServiceList.scss';
import { useTranslation } from 'react-i18next';

const isSync = syncSettings => !!syncSettings.find(setting => setting.isSyncedWithKintai);

const syncsWithLms = () => Cookies.get('using_jbc_lms') === 'true';

const ServiceList = ({ services, client, lmsSyncStatuses, accessToken, options }) => {
  const jbcKintaiSettings = services.jbcKintai || [];
  const { t } = useTranslation();
  const isSyncCommonId = options.isSyncCommonIdName || options.isSyncCommonIdStaffCode ? true : false

  return (
    <React.Fragment>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.Coordinations.ServiceList.service_link')}</h1>
        <p className="m-title-main-note">{t('features.Coordinations.ServiceList.you_can_link_to_other_services_such_as_JOBCAN_common_id')}</p>
      </div>
      <div className="l-wrap-s l-contents-wrap">
        <BreadCrumb>
          <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
          <BreadCrumb.Item label={t('features.Coordinations.ServiceList.service_link')} />
        </BreadCrumb>
        {client.planType === 'free_plan' && (
          <Section title={t('features.Coordinations.ServiceList.service_link')} className="u-mt40">
            <div>
              {t('features.Coordinations.ServiceList.Service_link_is_not_available_for_the_free_plan')}<br />
              {t('features.Coordinations.ServiceList.To_use_service_link_please_apply_for_paid_plan_from_below')}
            </div>
            <div className="u-mt50 u-mb20 u-ta-c">
              <Button success large as="a" href={EDIT_CLIENT_SETTING_USING_PLAN}>
                {t('features.Coordinations.ServiceList.Apply_for_paid_plan_here')}
              </Button>
            </div>
          </Section>
        )}
        {client.planType !== 'free_plan' && (
          <React.Fragment>
            <p className={styles.lead}>{t('features.Coordinations.ServiceList.you_can_link_information_of_each_item_with_API')}</p>
            <div className={styles.notes}>
              <div className={styles.serviceWrap}>
                <p className={styles.serviceName}>{t('features.Coordinations.ServiceList.JOBCAN_attendance_management')}</p>
                <p>{t('features.Coordinations.ServiceList.you_can_get_attendance_data')}</p>
              </div>
              <div className={styles.serviceWrap}>
                <p className={styles.serviceName}>{t('features.Coordinations.ServiceList.JBC_common_id')}</p>
                <p>{t('features.Coordinations.ServiceList.The_staff_code_name_and_email_address_will_be_automatically_linked_to_the_common_ID')}</p>
              </div>
              {/*
              <div className={styles.serviceWrap}>
                <p className={styles.serviceName}>{t('features.Coordinations.ServiceList.JOBCAN_labor_management')}</p>
                <ul className={styles.buttons}>
                  <li>
                    <Button as="a" href={EMPLOYEES_LIST}>
                      {t('features.Coordinations.ServiceList.Employee_information')}
                    </Button>
                  </li>
                  <li>
                    <Button as="a" href={LIST_CLIENTS_URL}>
                      {t('features.Settings.Settings.office_information')}
                    </Button>
                  </li>
                </ul>
                <p>{t('features.Coordinations.ServiceList.The_above_information_can_be_linked')}</p>
              </div>
              */}
            </div>
            <div className="l-overflow-scroll">
              <table className={styles.table}>
                <thead>
                  <tr>
                    <td />
                    <td>{t('features.Coordinations.ServiceList.service_name')}</td>
                    <td>{t('features.Coordinations.ServiceList.status')}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      <a href="https://jobcan.ne.jp/" rel="noopener noreferrer" target="_blank">
                        <KintaiLogo size={227} />
                      </a>
                    </th>
                    <td>
                      <a
                        href="https://ssl.jobcan.jp/login/client"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="u-txt-link"
                      >
                        {t('features.Coordinations.ServiceList.jbc_Attendance_Management')}
                      </a>
                    </td>
                    <td>
                      {isSync(jbcKintaiSettings) ? (
                        <div className={styles.linked}>
                          <Link size={23} />{t('features.Coordinations.ServiceList.linked')}<a href={COORDINATION_JBC_SETTINGS} className={styles.setting}>
                            {!_.isEmpty(accessToken) && <Setting size={18} />}
                          </a>
                        </div>
                      ) : (
                        <div className={styles.nolink}>
                          <UnLink size={23} />{t('features.Coordinations.ServiceList.not_linked')}<a href={COORDINATION_JBC_SETTINGS} className={styles.setting}>
                            {!_.isEmpty(accessToken) && <Setting size={18} />}
                          </a>
                        </div>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <td>
                      <a
                        href="https://id.jobcan.jp"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="u-txt-link"
                      >
                       {t('features.Coordinations.ServiceList.jbc_common_id')}
                      </a>
                    </td>
                    <td>
                      {isSyncCommonId ? (
                        <div className={styles.linked}>
                          <Link size={23} />{t('features.Coordinations.ServiceList.linked')}<a href={COORDINATION_COMMON_ID_SETTINGS} className={styles.setting}>
                            <Setting size={18} />
                          </a>
                        </div>
                      ) : (
                        <div className={styles.nolink}>
                          <Link size={23} />{t('features.Coordinations.ServiceList.not_linked')}<a href={COORDINATION_COMMON_ID_SETTINGS} className={styles.setting}>
                            <Setting size={18} />
                          </a>
                        </div>
                      )}
                    </td>
                  </tr>
                  {/*
                  <tr>
                    <th>
                      <a href="https://lms.jobcan.jp/" rel="noopener noreferrer" target="_blank">
                        <RoumuLogo size={222} />
                      </a>
                    </th>
                    <td>
                      <a
                        href="https://lms.jobcan.jp/login"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="u-txt-link"
                      >
                        {t('features.Coordinations.ServiceList.JOBCAN_Labor_Management')}
                      </a>
                    </td>
                    <td>
                      {syncsWithLms() ? (
                        <React.Fragment>
                          <div className={styles.linked}>
                            <Link size={23} />連携済
                          </div>
                          <div className={styles.linkedWrap}>
                            <dl className={styles.linkedDate}>
                              <dt>従業員情報の最終連携日時</dt>
                              <dd>
                                {lmsSyncStatuses.employee
                                  ? moment(lmsSyncStatuses.employee.syncedAt).format('LLL')
                                  : HYPHEN_CHARACTER}
                              </dd>
                            </dl>
                            <dl className={styles.linkedDate}>
                              <dt>法人情報の最終連携日時</dt>
                              <dd>
                                {lmsSyncStatuses.client
                                  ? moment(lmsSyncStatuses.client.syncedAt).format('LLL')
                                  : HYPHEN_CHARACTER}
                              </dd>
                            </dl>
                          </div>
                        </React.Fragment>
                      ) : (
                        <div className={styles.nolink}>
                          <UnLink size={23} />{t('features.Coordinations.ServiceList.not_linked')}
                        </div>
                      )}
                    </td>
                  </tr>
                  */}
                </tbody>
              </table>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default ServiceList;
